module.exports = __webpack_public_path__ + "img/stay-prepared-logo.e82c5acd.svg";